<template>
	<Card :title="voter.user.full_name">
		<template #badges>
			<Badge :color="badgeColor" active>{{ trans(`rotations.elections.voters.status.${voter.status}`) }}</Badge>
		</template>
		<AcademicCertificateStatus v-if="voter.is_pending" :key="`academic-certificate-user-${voter.user.id}`" :certificate="voter.user.last_academic_certificate"/>
		<template v-if="voter.is_pending" #footer>
			<PrimaryButton :color="Color.Green" @click.stop="accept">
				<i class="fa-solid fa-check mr-2"/>
				{{ trans('admin.periods.requests.actions.accept') }}
			</PrimaryButton>
			<SecondaryButton :color="Color.Red" @click.stop="reject">
				<i class="fa-solid fa-ban mr-2"/>
				{{ trans('admin.periods.requests.actions.reject') }}
			</SecondaryButton>
		</template>
	</Card>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/UI/Cards/Card.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import {type Rotation} from '@/Types/Periods/Rotations/Rotation'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {ref, type Ref, defineProps, ComputedRef, computed} from 'vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {type RotationVoter} from '@/Types/Periods/Rotations/RotationVoter'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import {getRotationParticipantStatusColor} from '@/Helpers/Association/Representatives/participants'
import AcademicCertificateStatus from '@/Components/Certificates/Academic/AcademicCertificateStatus.vue'

const props = defineProps<{
	rotation:Rotation,
	voter:RotationVoter,
}>()

const working:Ref<boolean> = ref(false)
const voter:Ref<RotationVoter> = ref(props.voter)
const rotation:Ref<Rotation> = ref(props.rotation)

const badgeColor:ComputedRef<Color> = computed(():Color => {
	return getRotationParticipantStatusColor(voter.value)
})

function accept():void{
	if(!working.value && voter.value.is_pending && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('association.representatives.rotations.voters.update', {
			rotation: rotation.value.id,
			voter: voter.value.id,
		}), {
			action: 'accept',
		}).then(({data}) => {
			voter.value = data
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}

function reject():void{
	if(!working.value && voter.value.is_pending && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('association.representatives.rotations.voters.update', {
			rotation: rotation.value.id,
			voter: voter.value.id,
		}), {
			action: 'reject',
		}).then(({data}) => {
			voter.value = data
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>